import { render, staticRenderFns } from "./EnviarReceta.vue?vue&type=template&id=379eb785&scoped=true"
import script from "./EnviarReceta.vue?vue&type=script&lang=js"
export * from "./EnviarReceta.vue?vue&type=script&lang=js"
import style0 from "./EnviarReceta.vue?vue&type=style&index=0&id=379eb785&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379eb785",
  null
  
)

export default component.exports